/** @module api/amperix_commission_infos */

import { apiCall } from '@/api/index'
import { addQueryParamsToReqPayload } from '@/api/configure'
import { byEmsApiV1AmperixCommissionInfosPath } from '@/../lib/routes'

export function getAmperixCommissionInfoByEms({ ctxt = 'admin', emsId, fields = [], filter = {}, sort = '' } = {}) {
  const payload = {}

  filter.id = emsId

  addQueryParamsToReqPayload(payload, 'energy_management_systems', { fields, filter, sort })

  return apiCall({
    path: byEmsApiV1AmperixCommissionInfosPath(ctxt),
    payload
  })
}
